import Checkbox from '@components/Checkbox'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useStyles from './SelectAll.styles'
import { LinkButton } from '@components/LinkButton/LinkButton'

interface Props {
  handleToggleSelectAll: () => void
  allPractitionersSelected: boolean
}

export const SelectAll = ({ handleToggleSelectAll, allPractitionersSelected }: Props) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <div className={classes.selectAllContainer}>
      <div className={classes.checkboxContainer}>
        <Checkbox onChange={handleToggleSelectAll} checked={allPractitionersSelected} name="select-all-checkbox" />
        <LinkButton
          className={classes.selectAllButton}
          text={allPractitionersSelected ? t('unselect_all_practitioners') : t('select_all_practitioners')}
          onClick={handleToggleSelectAll}
        />
        {!allPractitionersSelected && (
          <>
            &nbsp;<span className={classes.showAllSlots}>({t('shows_all_slots')})</span>
          </>
        )}
      </div>
    </div>
  )
}
